import { render, staticRenderFns } from "./ProductEditButton.vue?vue&type=template&id=b2d6374e&scoped=true&"
import script from "./ProductEditButton.vue?vue&type=script&lang=ts&"
export * from "./ProductEditButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductEditButton.vue?vue&type=style&index=0&id=b2d6374e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d6374e",
  null
  
)

export default component.exports